// ('EVENT', { type: 'search', keyword: searchTerm });
export const track = (key, opts) => {
  if (typeof window !== 'undefined' && window?.THD_EVENT_BUS?.trigger) {
    window.THD_EVENT_BUS.trigger(`delivery-options.${key}`, opts);
  }
};
